<template>
    <div id="down" @click="download">
        <img src="https://images.dayiketang.com/download-img.png"/>
    </div>
</template>
<script>
    export default {
        data(){
            return{

            }
        },
        methods:{
            download(){
                var agent = navigator.userAgent;
                var isIos = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                var isAndroid = agent.indexOf('Android') > -1 || agent.indexOf('Adr') > -1;
                if(isIos){
                    console.log('IOS下载');
                    window.location.href = 'https://apps.apple.com/us/app/肖瘤医生-医生端/id1539370671';
                }else{
                    console.log('安卓下载');
                    window.location.href = 'https://voives.dayiketang.com/XiaoLiuDoctor-release-v1.0.4.apk';
                }
            }
        }
    }
</script>
<style>
    * {
        padding: 0;
        margin: 0;
    }
    #down {
        width: 100%;
        max-width:37.5rem;
    }
    #down img {
        border: 0;
        max-width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/download/index.vue